import { HelpIcon } from '@change/ds-icons';

import { Card, Text } from '@change/ds-core-ui/next';

import type { NormalizedDecisionMaker } from '../../../../shared/types';
import { AvatarAndBadge } from '../../../shared/AvatarAndBadge';
import { DecisionMakerResponse } from '../../../shared/DecisionMakerResponse';
import { Name } from '../../../shared/Name';
import { ResponseBadge } from '../../../shared/ResponseBadge';

export const DecisionMakerCardMobile: React.FC<{ dm: NormalizedDecisionMaker }> = ({ dm }) => {
	const { displayName, id, title, photoUrl, publiclyVisible, slug, response } = dm;

	return (
		<Card className="mb-6 bg-white p-6 pb-8 shadow-md lg:hidden">
			<div className="flex gap-4">
				<div>
					<AvatarAndBadge displayName={displayName} photoUrl={photoUrl} />
				</div>

				<div className="w-full">
					<div className="flex w-full flex-col xl:flex-row">
						<div className="w-full">
							<div className="mr-1 w-full">
								<div className="flex items-center">
									<Name displayName={displayName} id={id} publiclyVisible={publiclyVisible} slug={slug} />
									<HelpIcon size={15} className="text-icon-strong" />
								</div>
							</div>

							<Text variant="body" className="mb-2 block">
								{title}
							</Text>
						</div>

						<div>
							<ResponseBadge response={response} />
						</div>
					</div>

					{response && <DecisionMakerResponse response={response} />}
				</div>
			</div>
		</Card>
	);
};
